export const FONTS = [
  {
    id: 'AmaticSC-Bold',
    name: 'Amatic Bold',
  },
  {
    id: 'AmaticSC-Regular',
    name: 'Amatic',
  },
  {
    id: 'Bangers-Regular',
    name: 'Bangers',
  },
  {
    id: 'Barrio-Regular',
    name: 'Barrio',
  },
  {
    id: 'Chango-Regular',
    name: 'Chango',
  },
  {
    id: 'Courgette-Regular',
    name: 'Courgette',
  },
  {
    id: 'Economica-Bold',
    name: 'Economica Bold',
  },
  {
    id: 'Economica-Regular',
    name: 'Economica',
  },
  {
    id: 'Graduate-Regular',
    name: 'Graduate',
  },
  {
    id: 'JollyLodger-Regular',
    name: 'Jolly Lodger',
  },
  {
    id: 'JosefinSlab-Bold',
    name: 'Josefin Slab Bold',
  },
  {
    id: 'JosefinSlab-Italic',
    name: 'Josefin Slab Italic',
  },
  {
    id: 'JosefinSlab-Light',
    name: 'Josefin Slab Light',
  },
  {
    id: 'Lato-Bold',
    name: 'Lato Bold',
  },
  {
    id: 'Lato-Light',
    name: 'Lato Light',
  },
  {
    id: 'Lato-Regular',
    name: 'Lato',
  },
  {
    id: 'Lobster-Regular',
    name: 'Lobster',
  },
  {
    id: 'DMSans-Bold',
    name: 'DM Sans Bold',
  },
  {
    id: 'Monoton-Regular',
    name: 'Monoton',
  },
  {
    id: 'Montserrat-Bold',
    name: 'Montserrat Bold',
  },
  {
    id: 'Montserrat-Light',
    name: 'Montserrat Light',
  },
  {
    id: 'Montserrat-Regular',
    name: 'Montserrat',
  },
  {
    id: 'OldStandard-Bold',
    name: 'Old Standard Bold',
  },
  {
    id: 'OldStandard-Italic',
    name: 'Old Standard Italic',
  },
  {
    id: 'Oswald-Bold',
    name: 'Oswald Bold',
  },
  {
    id: 'Oswald-Light',
    name: 'Oswald Light',
  },
  {
    id: 'Oswald-Regular',
    name: 'Oswald',
  },
  // {
  //   id: 'PTM55FT',
  //   name: 'Barrio',
  // },
  {
    id: 'Quicksand-Bold',
    name: 'Quicksand Bold',
  },
  {
    id: 'Quicksand-Regular',
    name: 'Quicksand',
  },
  {
    id: 'Raleway-Bold',
    name: 'Raleway Bold',
  },
  {
    id: 'Raleway-Italic',
    name: 'Raleway Italic',
  },
  {
    id: 'Raleway-Light',
    name: 'Raleway Light',
  },
  {
    id: 'SeaweedScript-Regular',
    name: 'Seaweed Script',
  },
  {
    id: 'Shrikhand-Regular',
    name: 'Shrikhand',
  },
  {
    id: 'SourceSansPro-Black',
    name: 'Source Sans Pro Black',
  },
  {
    id: 'SourceSansPro-Bold',
    name: 'Source Sans Pro Bold',
  },
  {
    id: 'StintUltraExpanded-Regular',
    name: 'Stint Ultra Expanded',
  },
  {
    id: 'VastShadow-Regular',
    name: 'Vast Shadow',
  },
  {
    id: 'Voltaire-Regular',
    name: 'Voltaire',
  },
];
